import { useState } from 'react'
import { Platform, StyleSheet, TouchableOpacity } from 'react-native'
import { ManualEntry } from './ManualEntry'
import { SuggestedBet } from './SuggestedBet'
import { translate } from '../../../../../../i18n'
import { DS } from '../../../../../../design-system'
const TABS = {
  'Suggested Bet': 'Suggested Bet',
  'Manual Entry': 'Manual Entry'
} as const

type TAB = keyof typeof TABS

interface TabsProps {
  onSelect: (amount: string) => void
  errorMsg: string
}

const isWeb = Platform.OS === 'web'

export const Tabs = ({ onSelect, errorMsg }: TabsProps) => {
  const [selectedTab, setSelectedTab] = useState<TAB>('Suggested Bet')

  return (
    <DS.Frame justifyContent="space-between" gap={'8'}>
      <DS.Frame row style={[styles.tabs, { gap: isWeb ? DS.spacing[8] : DS.spacing[4] }]}>
        <TouchableOpacity
          onPress={() => {
            setSelectedTab('Suggested Bet')
            onSelect('0')
          }}
          style={[styles.tab, selectedTab === 'Suggested Bet' ? styles.selectedTab : {}]}
        >
          <DS.Text variant="Body Small/Medium">{translate('gameScreen.betModal.suggestedBet')}</DS.Text>
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => {
            setSelectedTab('Manual Entry')
            onSelect('0')
          }}
          style={[styles.tab, selectedTab === 'Manual Entry' ? styles.selectedTab : {}]}
        >
          <DS.Text variant="Body Small/Medium">{translate('gameScreen.betModal.manualEntry')}</DS.Text>
        </TouchableOpacity>
      </DS.Frame>
      <DS.Frame flex={6}>
        {selectedTab === 'Suggested Bet' ? <SuggestedBet onSelect={onSelect} /> : null}
        {selectedTab === 'Manual Entry' ? <ManualEntry onSelect={onSelect} errorMsg={errorMsg} /> : null}
      </DS.Frame>
    </DS.Frame>
  )
}

const styles = StyleSheet.create({
  tabs: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    backgroundColor: DS.palette['Brand/Light Grey'],
    borderRadius: DS.spacing[32],
    padding: DS.spacing[4]
  },
  tab: {
    paddingVertical: DS.spacing[8],
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  selectedTab: {
    backgroundColor: 'white',
    borderRadius: DS.spacing[24],
    flex: 1
  }
})
